/**
 * Convert other casing to Title Case.
 * e.g. input: camel-kebab_SNAKE output: Camel Pascal Kebab Snake
 * Important Note: Candidate to move into fergy-utilities package.
 */

import { capitalize } from '@fergdigitalcommerce/fergy-utilities';

export const titleCase = (str: string) => {
	if (!str) {
		return str;
	}
	return str
		.split(/\s|\.|-|_/)
		.filter((e) => e !== '')
		.map((word) => capitalize(word))
		.join(' ');
};
